<template>
  <div class="flex flex-col flex-1 gap-2 px-4 border-t">
    <div
      class="flex justify-center items-center pt-6"
      @click="showImgUploadPopup = true"
    >
      <div
        :class="[
          'rounded-lg overflow-hidden flex justify-center items-center border  text-base-content/50 bg-base-200 ',
          reqData.source ? '' : 'w-full min-h-[10rem]',
        ]"
      >
        <BaseImg
          v-if="reqData.source"
          class="max-w-full"
          :media="{ url: reqData.source.url! }"
          fit="cover"
        />
        <div v-else>
          <button class="btn btn-xs rounded px-4">
            <!-- 编辑 -->
            {{ t(`painting.${isOrigin ? "origin" : "layout"}.upload`) }}
            <!-- {{ t(`painting.layout.upload`) }} -->
          </button>
        </div>
      </div>
    </div>
  </div>

  <media-select-popup
    @on-media-selected="onMediaSelected"
    enable-use-avatar
    media-type="img"
    :multiple="false"
    v-model:show="showImgUploadPopup"
    :upload-type="7"
    :max-count="1"
    :enable-crop="true"
    :enable-go-image-gen="false"
    :cropAspectRatio="cropAspectRatio"
    showRatioSelect
    @update:crop-aspect-ratio="onCropAspectRatioChange"
    replace
  />
</template>

<script setup lang="ts">
import { MediaUploadFileItem } from "@/types/component";
import { PropType } from "vue";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
  reqData: {
    type: Object as PropType<PromptJson>,
    required: true,
  },
  isOrigin: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["uploadNsfwImage"]);
const { t } = useI18n();
const showImgUploadPopup = ref(false);

const onMediaSelected = (list: MediaUploadFileItem[]) => {
  if (list.length > 0) {
    if (list[0].isNsfw) {
      emit("uploadNsfwImage", {
        id: list[0].mediaId,
        isNsfw: list[0].isNsfw,
        url: list[0].url,
      });
    } else {
      // @ts-ignore
      props.reqData.source = list[0];
      props.reqData.sourceId = list[0].mediaId;
      props.reqData.ratio = cropAspectRatio.value === 3 / 4 ? "3:4" : "16:9";
    }
  }
};

const cropAspectRatio = ref(3 / 4);
const onCropAspectRatioChange = (_ratio: string) => {
  const [w, h] = _ratio.split(":").map(Number);
  cropAspectRatio.value = w / h;
};
</script>
